import { render, staticRenderFns } from "./dish-modal.vue?vue&type=template&id=743f478c&"
import script from "./dish-modal.vue?vue&type=script&lang=js&"
export * from "./dish-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports